import type { ReactElement } from 'react';

export default function SidebarPlusTag(): ReactElement {
  return (
    <span className="vtwo:flex vtwo:h-4 vtwo:shrink-0 vtwo:items-center vtwo:rounded vtwo:bg-linear-to-r vtwo:from-[#f3e6fe] vtwo:to-[#d9eefe] vtwo:px-1">
      <span className="vtwo:bg-linear-to-r vtwo:from-[#8244ba] vtwo:to-[#206b9f] vtwo:bg-clip-text vtwo:text-[10px] vtwo:font-bold vtwo:leading-none vtwo:text-transparent">
        Plus<span className="vtwo:font-semibold vtwo:italic">+</span>
      </span>
    </span>
  );
}
